import { useContext, useEffect, useState } from 'react'

import { Grid } from '@mui/material'

import Parser from 'html-react-parser'

import { AccordionListItem } from '../../components/AccordionListItem'
import { LoadingText } from '../../components/LoadingText'
import { Search } from '../../components/Search'
import { AuthContext } from '../../contexts/auth'
import { IFAQ } from '../../sdk/settings/settings.types'
import { sdk } from '../../services/sdk'

import styles from './styles.module.scss'

export const Faq = () => {
  const [search, setSearch] = useState('')
  const [data, setData] = useState<IFAQ[] | null>()
  const [loading, setLoading] = useState(false)
  const { user } = useContext(AuthContext)

  const getFaq = async () => {
    try {
      setLoading(true)
      const response = await sdk.settings.getFAQ()
      setData(response.faq)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getFaq()
  }, [])

  const filterResult =
    data &&
    data.filter((item) =>
      item.question.toLowerCase().includes(search.toLowerCase()),
    )

  return (
    <div className={styles.container}>
      <Grid container spacing={2}>
        <Grid item sm={3}>
          <Search
            label="Pesquisa"
            onChange={(e) => {
              setSearch(e.target.value)
            }}
            value={search}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item sm={12}>
          {filterResult && filterResult.length > 0 && !loading ? (
            filterResult.map((item, index) => {
              if (
                user &&
                (user.company.segment?.includes(item.type) ||
                  item.type === 'all')
              ) {
                return (
                  <AccordionListItem
                    key={index}
                    header={{
                      cellSizes: [12],
                      items: [
                        {
                          label: 'Pergunta',
                          value: (
                            <h4 className={styles.value}>{item.question}</h4>
                          ),
                        },
                      ],
                    }}
                    renderContent={
                      <div className={styles.answer}>{Parser(item.answer)}</div>
                    }
                  />
                )
              }
              return null
            })
          ) : loading ? (
            <LoadingText />
          ) : (
            <p>Nenhuma pergunta localizada com esses parâmetros</p>
          )}
        </Grid>
      </Grid>
    </div>
  )
}
